<template>
        <div id="modal-tech-name-set" class="modal fade" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="container">
                        <div class="row my-4">
                            <div class="col-6">氏名公開設定</div>
                            <div class="col p-0">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" v-model="pub" class="custom-control-input" id="techNameSet">
                                    <label class="custom-control-label" for="techNameSet">{{this.setLabel}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button class="btn btn-danger" type="button" @click="techNamePub">
                        設定する
                    </button>
                    <button class="btn btn-success" type="button" @click="hideThis">
                        &nbsp;&nbsp;閉じる&nbsp;&nbsp;
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                id: "",
                pub: false
            }
        },
        watch: {
            getAppNamePubStatus (status) {
                if (status == 0) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            setLabel () {
                return this.pub ? '公開' : '非公開'
            },
            ...mapGetters(['getAppNamePubStatus'])
        },
        methods: {
            openThis (item) {
                this.resetThis()
                this.id = item.ai_id
                this.pub = item.name_pub == '0' ? true : false
                $('#modal-tech-name-set').modal('show')
            },
            hideThis () {
                this.resetThis()
                $('#modal-tech-name-set').modal('hide')
            },
            resetThis () {
                this.id = ""
                this.pub = false
            },
            techNamePub () {
                this.$store.dispatch('techNamePub', {
                    id: this.id,
                    pub: this.pub
                })
            }
        }
    }
</script>

<style>

</style>
